import { useMemo } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { SellerProfile } from "../../stores/seller-store/seller-store.model";
import { MobileContainer } from "../../components/layouts/app/mobile-container";
import { IconArrowLeft } from "../../components/icons/icon-arrow-left";
import { CredimartInfoBody } from "./credimart-info-body";
import { CredistoreInfoBody } from "./credistore-info-body";
import { isCrediMart } from "../../utils/helper";
import { SellerPageRouter } from "../seller/page-router.props";

interface SellerInfoModuleProps {
  sellerData: SellerProfile;
}

export const SellerInfoModule = ({ sellerData }: SellerInfoModuleProps) => {
  const router: SellerPageRouter = useRouter();
  const isCredimartApp = useMemo(() => isCrediMart(), []);

  const handleBack = () => {
    if (!window?.__prevPathname) {
      router.push(`/${router.query.seller}`);
    } else {
      router.back();
    }
  };

  if (!sellerData) {
    return (
      <MobileContainer>
        <IconArrowLeft
          onClick={handleBack}
          className="relative top-4 left-4 cursor-pointer"
        />
        <div className="mt-[60px] text-center">
          <Image
            src={`/img/${process.env.NEXT_PUBLIC_APP_NAME}/empty-store.svg`}
            alt="empty"
            width="200"
            height="200"
            className="mx-auto"
          />
          <div className="mt-3">
            <div className="text-title-sm font-bold">Toko Tidak Ditemukan</div>
            <button
              className="mt-3 px-4 py-2 text-white rounded select-none bg-primary"
              onClick={async () => await router.push(`/${router.query.seller}`)}
            >
              Kembali
            </button>
          </div>
        </div>
      </MobileContainer>
    );
  }

  return (
    <MobileContainer sellerData={sellerData}>
      <main className="relative size-full bg-fill-gray">
        <div className="p-4 bg-white">
          <IconArrowLeft
            onClick={async () => await router.push(`/${router.query.seller}`)}
            className="cursor-pointer"
          />
          {/* TODO: replace to use CredimartInfoBody for both app. wait until credistore app support desc(additional_address) input */}
          {isCredimartApp ? (
            <CredimartInfoBody sellerData={sellerData} />
          ) : (
            <CredistoreInfoBody sellerData={sellerData} />
          )}
        </div>
      </main>
    </MobileContainer>
  );
};
